export default {
  title: 'Notifications de réservation',
  label: 'À quelle adresse devons-nous envoyer les notifications de réservation ?',
  placeholder: 'p. ex. reservations@votrerestaurant.fr',
  helper:
    "Toute adresse e-mail convient — aucun accès au tableau de bord n'est nécessaire. Vous pourrez la modifier ou en ajouter d'autres plus tard dans Réservations → Paramètres → Notifications et confirmation.",
  errors: {
    required: 'Ajoutez une adresse e-mail pour recevoir les notifications de réservation.',
    invalid: 'Saisissez une adresse e-mail valide, comme nom@restaurant.fr.',
  },
};
